import { render, staticRenderFns } from "./RouterInformation.vue?vue&type=template&id=96995102"
import script from "./RouterInformation.vue?vue&type=script&lang=js"
export * from "./RouterInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports